import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { reduxKey } from './constants';
import { createSelector } from 'reselect';
import { getPublicSession } from '../../publicSession/selectors';
function getBiStore(state) {
    return state[reduxKey] || {
        pageview: {}
    };
}
export function getPageBiContext(state) {
    return getBiStore(state).pageview;
}
export const getPageViewAndComponent = createSelector([
    getPageBiContext
], ({ component , view  })=>{
    return {
        component,
        view
    };
});
export function getBiContextData(state) {
    return _object_spread({}, getPublicSession(state), getPageViewAndComponent(state));
}
